<template>
  <div class="signup">
    <NavHeaderBar title="大会注册" :onClickRight="onClickRight" :onClickLeft="onClickLeft" rightArrow />
    <van-notice-bar class="msg" wrapable :scrollable="false">
      <span>
        <van-icon class="msg-icon" name="volume-o" />

        {{
            signprompt
              ? signprompt
              : `本直播仅供医药专业人士收看!收看前需先通过身份认证!`
        }}

      </span>
    </van-notice-bar>
    <van-form ref="form" @submit="onSubmit">
      <template v-for="item in tableList">
        <van-field v-if="item.fieldname === 'uname'" :key="item.fieldname" v-model="form[item.fieldname]"
          :name="item.fieldname" :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
          :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]" />

        <div v-if="item.fieldname === 'shouji'" :key="item.fieldname">
          <van-field v-model="form[item.fieldname]" type="tel" :name="item.fieldname" placeholder="请输入手机号"
            :label="item.fieldtitle" :rules="[
              {
                pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
                message: '请填写正确的手机号'
              }
            ]" />
          <van-field v-if="needCaptcha" v-model="form.captcha" type="text" name="captcha" placeholder="验证码" label="验证码"
            :rules="[{ required: true, message: '请填写验证码' }]">
            <template #button>
              <span style="font-size: 13px;color: #999999" @click="onClickCaptch(item.fieldname)">
                | 获取验证码
                {{
                    captchaDisabledOverTime && captchaDisabledOverTime + "s"
                }}</span>
            </template>
          </van-field>
        </div>

        <van-field v-if="item.fieldname === 'xieb'" :key="item.fieldname" :name="item.fieldname"
          :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
          :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]">
          <template #input>
            <van-radio-group v-model="form[item.fieldname]" direction="horizontal">
              <van-radio v-for="sex in item.codelist" :key="sex.codeval" :name="sex.codeval">{{ sex.codename }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <div v-if="item.fieldname === 'jisdj'" :key="item.fieldname">
          <van-field :name="item.fieldname" :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
            :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]" readonly clickable
            v-model="form[item.fieldname]" @click="showPicker = true" />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="jisdjs" @confirm="onJisdjConfirm" @cancel="showPicker = false" />
          </van-popup>
        </div>

        <van-field v-if="item.fieldname === 'danwei'" :key="item.fieldname" v-model="form[item.fieldname]"
          :name="item.fieldname" :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
          :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]" />

        <van-field v-if="item.fieldname === 'zw'" :key="item.fieldname" v-model="form[item.fieldname]"
          :name="item.fieldname" :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
          :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]" />

        <div v-if="item.fieldname === 'shenshi'" :key="item.fieldname">
          <van-field :name="item.fieldname" :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
            :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]" readonly clickable
            v-model="form[item.fieldname]" @click="showArea = true" />
          <van-popup v-model="showArea" position="bottom">
            <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showArea = false" />
          </van-popup>
        </div>

        <div v-if="item.fieldname === 'companytype'" :key="item.fieldname">
          <van-field :name="item.fieldname" :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
            :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]" readonly clickable
            v-model="form[item.fieldname]" @click="showType = true" />
          <van-popup v-model="showType" position="bottom">
            <van-picker show-toolbar :columns="types" @confirm="onTypesConfirm" @cancel="showType = false" />
          </van-popup>
        </div>

        <van-field v-if="item.fieldname === 'email'" :key="item.fieldname" v-model="form[item.fieldname]"
          :name="item.fieldname" :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`" :rules="[
            { required: true, message: '请输入邮箱号!' },
            {
              pattern: /^\w+@[a-z0-9]+\.[a-z]+$/i,
              message: '邮箱号格式错误！'
            }
          ]" />

        <!-- 备用表单部分，备用字段统一spare开头，通过这个特征判断 -->
        <!-- 由于备用表单元素不确定性，所以需要依靠返回数据来渲染 -->
        <template v-if="item.fieldname.search('spare') === 0">
          <!-- input -->
          <van-field v-if="item.htmltype === 'text'" :key="item.fieldname" v-model="form[item.fieldname]"
            :name="item.fieldname" :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
            :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]" />

          <!-- 单选 -->
          <van-field v-if="item.htmltype === 'select'" :key="item.fieldname" :name="item.fieldname"
            :label="item.fieldtitle" :placeholder="`请输入${item.fieldtitle}`"
            :rules="[{ required: true, message: `请输入${item.fieldtitle}` }]">
            <template #input>
              <van-radio-group v-model="form[item.fieldname]" direction="horizontal">
                <van-radio v-for="code in item.codelist" :key="code.codeval" :name="code.codeval">{{ code.codename }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </template>
      </template>

      <div style="margin: 16px;" v-if="tableList && tableList.length > 0">
        <van-button block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import captcha from "@/mixins/captcha";
import { getEnv } from "@/config/utils";
import share from "@/mixins/share";
import { areaList } from "@vant/area-data";
import { fetchNeedcaptcha, signUpLive } from "@/config/conference";
import apis from "@/config/apis";
import { Dialog } from "vant";
export default {
  mixins: [captcha, share],

  name: "Register",
  data: () => ({
    tableList: [],
    signprompt: "",
    form: {
      uname: ""
    },
    jisdjs: [
      "主任医师",
      "主任药师",
      "主任护师",
      "主任技师",
      "副主任医师",
      "副主任药师",
      "副主任护师",
      "副主任技师",
      "主治（主管）医师",
      "主管药师",
      "主管护师",
      "主管技师",
      "医师、医士",
      "药师、药士",
      "护师、护士",
      "技师、技士",
      "其他"
    ],
    areaList,
    types: ["医院", "药房", "科研机构", "其他"],
    showPicker: false,
    showArea: false,
    showType: false,
    needCaptcha: true
  }),
  created() {
    this.getSignUpTable();
    this.getNeedcaptcha();
  },
  methods: {
    onClickRight() {
      this.$router.push({
        path: "/conference",
        query: { code: this.$route.query.code }
      });
    },

    onClickLeft() {
      this.$router.push({
        path: "/conference",
        query: { code: this.$route.query.code }
      });
    },


    async getSignUpTable() {
      try {
        const { code } = this.$route.query;
        const resp = await apis.detail.getSignUpTable(code || "");
        const {
          success,
          tablelist,
          signprompt,
          share,
          sharedesc,
          shareimg
        } = resp;
        if (success === "ok") {
          this.tableList = tablelist;
          this.signprompt = signprompt;
          if (resp.signStatus == 1) {
            Dialog.alert({
              title: "温馨提示",
              message: "您已经报过名了，点击确定返回会议首页"
            }).then(() => {
              this.$router.push({
                path: "/conference",
                query: { code: this.$route.query.code }
              });
            });
          }
          if (getEnv() !== "h5") {
            let shars = {};
            shars.shareId = this.$route.query.shareId || "0";
            shars.bizId = this.$route.query.bizId || resp.id;

            const bizType = "5";
            const url =
              window.location.href.split("?")[0] +
              "?code=" +
              this.$route.query.code +
              "&id=" +
              this.$route.query.id +
              "&regJumpUrl=" +
              this.$route.query.regJumpUrl;

            this.share(
              bizType,
              url,
              shars,
              shareimg,
              sharedesc,
              share,
              undefined
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onSubmit(values) {
      try {
        if (values.xieb === "null") {
          this.$toast("未选择性别");
        } else {
          const { code, id, regJumpUrl } = this.$route.query;
          values.zboCode = code;
          values.meetingPageFunRegisterItemId = id;
          const resp = await signUpLive(values);
          const { success, msg } = resp;
          if (success === "ok") {
            // this.$router.go(-1);


            Dialog.alert({
              title: "温馨提示",
              message: "报名成功"
            }).then(() => {
              if (regJumpUrl) {
                setTimeout(() => {
                  window.location.href = regJumpUrl;
                }, 2000);
              }
              else {
                this.$router.push("/conference?code=" + code);
              }
            });

            // this.$toast("报名成功");
            // if (regJumpUrl) {
            //   setTimeout(() => {
            //     window.location.href = regJumpUrl;
            //   }, 2000);
            // }
          } else {
            this.$toast.fail(msg);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    onClickCaptch(name) {
      this.$refs.form
        .validate([name])
        .then(() => {
          this.onClickGetCaptcha(this.form[name], 2);
        })
        .catch(err => {
          console.log(err);
        });
    },
    onJisdjConfirm(value) {
      this.form.jisdj = value;
      this.showPicker = false;
    },
    onAreaConfirm(values) {
      this.form.shenshi = values
        .filter(item => !!item)
        .map(item => item.name)
        .join("/");
      this.showArea = false;
    },
    onTypesConfirm(value) {
      this.form.companytype = value;
      this.showPicker = false;
    },
    // 获取是否需要验证码
    async getNeedcaptcha() {
      const { code } = this.$route.query;
      try {
        const resp = await fetchNeedcaptcha(code);
        const { success, needcaptcha } = resp;
        if (success === "ok") {
          this.needCaptcha = needcaptcha;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
.signup {
  padding-top: 46px;

  .msg {
    font-size: 13px;
    padding: 15px;
    line-height: 1.4;

    .msg-icon {
      margin-right: 4px;
      vertical-align: text-top;
    }
  }
}
</style>
